module.exports = __webpack_public_path__ + "img/cardWater.718ed40f.png";